import { useMutation } from '@tanstack/react-query';
import { QUERY_KEYS } from '../constants';
import { API_ROUTES } from '../constants/apiRoutes';
import { postData } from '../utils/api';
import { useInvalidateQuery } from '../hooks/useInvalidateQuery';
import {
  withdrawalPreviewSchema,
  withdrawalResultSchema,
  type ZeroXWithdrawalInput,
  type ZeroXWithdrawalPreview,
  type ZeroXWithdrawalResult,
} from '../schemas/zeroXWithdrawal';

// Both responses are parsed at the boundary: the preview's token is sent to an irreversible endpoint.
export const useZeroXWithdrawalPreview = () =>
  useMutation<ZeroXWithdrawalPreview, Error, ZeroXWithdrawalInput>({
    mutationFn: async (body) => {
      const response = await postData(API_ROUTES.ZERO_X.WITHDRAWAL_PREVIEW, body, 'wallet');

      return withdrawalPreviewSchema.parse(response);
    },
    retry: false,
  });

export const useZeroXWithdrawalConfirm = () => {
  const invalidate = useInvalidateQuery();

  return useMutation<ZeroXWithdrawalResult, Error, { confirmationToken: string }>({
    mutationFn: async (body) => {
      const response = await postData(API_ROUTES.ZERO_X.WITHDRAWALS, body, 'wallet');

      return withdrawalResultSchema.parse(response);
    },
    retry: false,
    onSuccess: () => invalidate([QUERY_KEYS.balance, API_ROUTES.WALLET_TRANSACTIONS_HISTORY.PLAYER]),
  });
};
